import { Route, Routes as DOMRoutes, Navigate } from 'react-router-dom'
import FAQ from '@app/customer/FAQ'
import OrderConfirmation from '@app/customer/OrderConfirmation/OrderConfirmation'
import {
  CustomerDetails,
  ModelCheck,
  PaymentDetails,
  PurchaseCheck,
  ShippingDetails,
  TradeInDetails,
} from '@app/customer/Quiz'
import { AccessDenied, AuthCallback, AuthLogout } from '@app/shared/Auth'
import ProtectedRoute from '@app/shared/ProtectedRoute'
import React, { Suspense, lazy } from 'react'
import { CookiePolicy, PrivacyPolicy, Terms } from '@app/customer/Policies'
import CustomerApp from '@app/customer/CustomerApp'
import NotFound from '@app/customer/NotFound/NotFound'
import CampaignClosed from '@app/customer/CampaignClosed'
import Home from '@app/customer/Home'
import urls from './urls'

const OrderList = lazy(() => import('@app/backoffice/OrderList'))
const Order = lazy(() => import('@app/backoffice/Order/Order'))

const Routes = () => {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <DOMRoutes>
        {/** Auth Routes */}
        <Route path="/authentication/callback" element={<AuthCallback />} />
        <Route path={urls.signOut} element={<AuthLogout />} />
        <Route path={urls.accessDenied} element={<AccessDenied />} />

        {/** Backoffice Routes */}
        <Route path={urls.backoffice} element={<ProtectedRoute />}>
          <Route index element={<OrderList />} />
          <Route path="order/:id" element={<Order />} />
        </Route>

        <Route element={<CustomerApp />}>
          <Route index element={<Navigate to="/de" />} />
          <Route path={`${urls.root}/:program/:campaign?`} element={<Home />} />
          <Route path={`${urls.root}/:program/:campaign?/${urls.closed}`} element={<CampaignClosed />} />
          <Route path={`:program/:campaign?/${urls.faqs}`}>
            <Route index element={<FAQ />} />
          </Route>
          <Route path={`:program/:campaign?/${urls.quiz}`}>
            <Route path="customer" element={<CustomerDetails />} />
            <Route path="model" element={<ModelCheck />} />
            <Route path="purchase" element={<PurchaseCheck />} />
            <Route path="valuation" element={<TradeInDetails />} />
            <Route path="shipping" element={<ShippingDetails />} />
            <Route path="payment" element={<PaymentDetails />} />
          </Route>
          <Route path=":program/:campaign?/order-complete/:id" element={<OrderConfirmation />} />
          <Route path={`:program/:campaign?/${urls.cookies}`} element={<CookiePolicy />} />
          <Route path={`:program/:campaign?/${urls.privacy}`} element={<PrivacyPolicy />} />
          <Route path={`:program/:campaign?/${urls.terms}`} element={<Terms />} />
          <Route path={urls.notFound} element={<NotFound />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </DOMRoutes>
    </Suspense>
  )
}

export default Routes
